module.exports = __webpack_public_path__ + "static/media/kanban.e55bfe96.png";